/*
 * Creative Cycles Workshop compact menu cards (Shop, About), patch 003.
 *
 * The cards open on hover and on keyboard focus with CSS. This adds what CSS cannot:
 * aria-expanded on the item's link so screen readers hear the open state, and Escape to dismiss the
 * card and return focus to its link (WCAG 1.4.13). The card stays dismissed until the pointer or
 * focus leaves the item. On product pages it also adds ?about=<product name> to links to Contact.
 */
(() => {
  const setup = (item) => {
    const link = item.querySelector('.menu-list__link');
    if (!link) return;
    link.setAttribute('aria-haspopup', 'true');
    link.setAttribute('aria-expanded', 'false');
    const open = () => { if (!item.classList.contains('is-dismissed')) link.setAttribute('aria-expanded', 'true'); };
    const close = () => { item.classList.remove('is-dismissed'); link.setAttribute('aria-expanded', 'false'); };
    item.addEventListener('pointerenter', open);
    item.addEventListener('focusin', open);
    item.addEventListener('pointerleave', close);
    item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) close(); });
    item.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      item.classList.add('is-dismissed');
      link.setAttribute('aria-expanded', 'false');
      link.focus();
    });
  };
  // Product pages: carry the product name to Contact so "Contact us about this bike" keeps the bike.
  const carryProduct = () => {
    if (!document.body.classList.contains('ccw-template-product')) return;
    const title = document.querySelector('main h1')?.textContent.trim();
    if (!title) return;
    const oneOff = !!document.querySelector('[data-ccw-one-off]');
    document.querySelectorAll('main a[href$="/pages/contact"]').forEach((a) => {
      // The template label is "Ask about this item"; bikes and framesets get the bike wording.
      if (oneOff && a.textContent.trim() === 'Ask about this item') a.textContent = 'Enquire about this bike';
      const url = new URL(a.href, location.origin);
      url.searchParams.set('about', title);
      a.href = url.pathname + url.search;
    });
  };
  const run = () => { document.querySelectorAll('.ccw-menu-item--card').forEach(setup); carryProduct(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  // Collection filters: leave empty price boxes out of the URL, as Horizon's own filters do, so an
  // empty From or To is not read as an active price filter
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('ccw-filters')) return;
    form.querySelectorAll('input[type="number"]').forEach((input) => {
      if (input.value === '') input.disabled = true;
    });
  });

  // "More bikes and parts": drop enquiry-only bikes (same illustration, no cart) and keep four
  const tidyRecommendations = (root) => {
    const skip = window.ccwEnquiryOnly || [];
    const items = [...root.querySelectorAll('.resource-list__item')];
    if (!items.length) return false;
    let shown = 0;
    items.forEach((item) => {
      const href = item.querySelector('a[href*="/products/"]')?.getAttribute('href') || '';
      const handle = href.split('/products/')[1]?.split(/[?#]/)[0];
      const keep = handle && !skip.includes(handle) && shown < 4;
      item.hidden = !keep;
      if (keep) shown += 1;
    });
    root.hidden = shown === 0;
    return true;
  };
  document.querySelectorAll('product-recommendations').forEach((root) => {
    if (tidyRecommendations(root)) return;
    const watch = new MutationObserver(() => { if (tidyRecommendations(root)) watch.disconnect(); });
    watch.observe(root, { childList: true, subtree: true });
  });
})();
